import React from 'react';
import jQuery from 'jquery';
import useMediaSelect from "app/app/mediaSelector/hooks/use-media-select";
import useMediaContext from "app/app/mediaSelector/hooks/use-media-context";

function useMediaDownload() {
    const [loading, setLoading] = React.useState(false);
    const allMediaFiles = useMediaContext();
    const {selectedMedia} = useMediaSelect();
    const url = window.ajaxurl;

    const downloadSelectedMedia = () => {
        if(selectedMedia.length <= 0) return;

        const selectedMediaUrls = selectedMedia.map(media => media.url);

        jQuery.ajax({
            type: "POST",
            url: url,
            data: {
                action: "download_media_files",
                mediaFiles: selectedMediaUrls,
            },
            dataType: 'JSON',
            beforeSend: () => setLoading(true),
            success: (response) => {
                window.location = `${response.data.url}?file=${response.data.file}`;
                setLoading(false);
            },
            error: (e) => {
                console.error('There was an error while trying to download the zip file please contact Ulandssekretariatet')
                setLoading(false);
            }
        })
    }

    const downloadAllMedia = () => {

        const downloadableMediaFiles = allMediaFiles.filter(mediaFile =>  mediaFile.isNotDownloadable !== true);
        const downloadableMediaUrls = downloadableMediaFiles.map(mediaFile => mediaFile.url);

        jQuery.ajax({
            type: "POST",
            url: url,
            data: {
                action: "download_media_files",
                mediaFiles: downloadableMediaUrls,
            },
            dataType: 'JSON',
            beforeSend: () => setLoading(true),
            success: (response) => {
                window.location = `${response.data.url}?file=${response.data.file}`;
                setLoading(false);
            },
            error: (e) => {
                console.error('There was an error while trying to download the zip file please contact Ulandssekretariatet')
                setLoading(false);
            }
        })
    }

    React.useEffect(() => {
        const downloadAllButton = document.getElementById('download-all-media');
        downloadAllButton.addEventListener('click', downloadAllMedia)

        return () => downloadAllButton.removeEventListener('click', downloadAllMedia)
    }, [])

    return [downloadSelectedMedia, loading];
}

export default useMediaDownload;
